import { type MoveEvent, bounceAttackers, other } from '@chessbut/engine';
import type { Decoration, VariantUi } from './ui.ts';

const BOUNCE = '/art/bounce.svg';
const isBounce = (e: MoveEvent) => e.t === 'fx' && e.kind === 'bounce';

export const bounceUi: VariantUi = {
  heroImage: BOUNCE,
  peek: [{}, { image: '/art/bK.svg', threat: true }, {}, { image: BOUNCE }, {}, {}, {}, { image: '/art/wB.svg' }, {}],

  decorations(pos) {
    // Show the path of a check that comes off the rail: it's easy to miss.
    const k = pos.royals[pos.turn];
    if (k < 0) return [];
    const out: Decoration[] = [];
    for (const { from, via } of bounceAttackers(pos.board, k, other(pos.turn))) {
      out.push({ kind: 'arrow', from, to: via, tone: 'danger' }, { kind: 'arrow', from: via, to: k, tone: 'danger' });
    }
    return out;
  },

  twist(pos, you) {
    const k = pos.royals[pos.turn];
    if (k >= 0 && bounceAttackers(pos.board, k, other(pos.turn)).length) {
      const yours = you === null || you === pos.turn;
      return { text: yours ? 'Bank shot! Your king is in check off the rail' : 'Bank shot! Their king is in check off the rail', alert: yours };
    }
    return { text: 'Bishops can bounce off the edge once. Watch the rails.' };
  },

  eventSound(e) {
    return isBounce(e) ? 'boing' : null;
  },

  moveBadge(rec) {
    return rec.events.some(isBounce) ? { icon: BOUNCE, victim: rec.captured || undefined, title: 'Bounce shot' } : null;
  },
};
